import { AdminDocumentsMandatoryFilterItemsStorage } from './upload-documents/filter/admin-documents-mandatory-filter-items-storage';
import { AdminFormFieldsModule } from './form-fields/admin-form-fields.module';
import { UploadDialogTypeResolver } from './upload-documents/category-upload-dialogs/upload-dialog-type-resolver';
import { AdminDocumentColumns } from './upload-documents/admin-document-columns';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { QuillModule } from 'ngx-quill';
import { CovanceAgGridModule } from '../covance-ag-grid/covance-ag-grid.module';
import { CovanceDatePickerModule } from '../covance-date-picker/covance-date-picker.module';
import { CovanceFileUploadModule } from '../covance-file-upload/covance-file-upload.module';
import { DocumentsModule } from '../documents/documents.module';
import { GlobalPopupModule } from '../global-popup';
import { NavigationModule } from '../navigation';
import { SharedModule } from '../shared';
import { UserModule } from '../user';
import { AuditTrailModule } from './../audit-trail/audit-trail.module';
import { CovanceFilterModule } from './../covance-filter/covance-filter.module';
import { CovanceTextFieldModule } from './../covance-textfield/covance-textfield.module';
import { InvestigatorModule } from './../investigator/investigator.module';
import { AdminGuard } from './admin-guard';
import { AdminLevelComponent } from './admin-level.component';
import { AdminSharedModule } from './admin-shared.module';
import { AnnouncementEditDialogComponent } from './announcements/announcement-edit-dialog.component';
import { AnnouncementsActionsMenuAgRendererComponent } from './announcements/announcements-actions-menu-ag-renderer.component';
import { AnnouncementsAdminComponent } from './announcements/announcements-admin.component';
import { AnnouncementsInfoStorage } from './announcements/announcements-info-storage';
import { AnnouncementDeleteDialogComponent } from './announcements/delete-announcement-dialog.component';
import { AuditTrailExportComponent } from './audit-trail-export/audit-trail-export.component';
import { AuditTrailRecordsStorage } from './audit-trail-export/audit-trail-records-storage';
import { AdminKitInventoryComponent } from './kit-inventory/admin-kit-inventory.component';
import { CommonLinkActionsMenuAgRendererComponent } from './common-links/common-link-actions-menu-ag-renderer.component';
import { CommonLinkEditorComponent } from './common-links/common-link-editor.component';
import { CommonLinksInfoEditor } from './common-links/common-links-editor';
import { CommonLinksGridComponent } from './common-links/common-links-grid.component';
import { CommonLinksInfoStorage } from './common-links/common-links-info-storage';
import { AdminLinksInfoStorage } from './navigation/admin-links-info-storage';
import { AdminNavigationComponent } from './navigation/admin-navigation.component';
import { ProtocolActivationComponent } from './protocol-activation/protocol-activation.component';
import { ProtocolChangeAccessibilityComponent } from './protocol-activation/protocol-change-accessibility.component';
import { AdminProtocolsStorage, ProjectsStorage } from './shared';
import { GridColumns } from '../shared/grid-columns';
import { AccessionsStorage } from './shared/accessions-storage';
import { AdminSubjectsStorage } from './shared/admin-subjects-storage';
import { EQueryStorage } from './e-query/e-query-storage';
import { StandardTitlesStorage } from './shared/standard-titles-storage';
import { AdminActivityReportsModule } from './activity-reports/admin-activity-reports.module';
import { SetDefaultAdminDocumentsFiltersGuard } from './upload-documents/set-default-admin-documents-filters-guard';
import { AdminUnreadReportStorage } from './upload-documents/admin-unread-reports-storage';
import { UploadConfirmationDialog } from './upload-documents/category-upload-dialogs/base/upload-confirmation-dialog';
import { UploadDialogActionButtonsComponent } from './upload-documents/category-upload-dialogs/base/upload-dialog-action-buttons.component';
import { UploadProgressComponent } from './upload-documents/category-upload-dialogs/base/upload-progress.component';
import { ApplicationTrainingInfoComponent } from './upload-documents/category-upload-dialogs/document-info-dumb-components/application-training-info.component';
import { GeneralDocumentInfoComponent } from './upload-documents/category-upload-dialogs/document-info-dumb-components/general-document-info.component';
import { SiteCommunicationsInfoComponent } from './upload-documents/category-upload-dialogs/document-info-dumb-components/site-communications-info.component';
import { SponsorCommunicationsInfoComponent } from './upload-documents/category-upload-dialogs/document-info-dumb-components/sponsor-communications-info.component';
import { StudyManualInfoComponent } from './upload-documents/category-upload-dialogs/document-info-dumb-components/study-manual-info.component';
import { TrainingMaterialsInfoComponent } from './upload-documents/category-upload-dialogs/document-info-dumb-components/training-materials-info.component';
import { FileEditComponent } from './upload-documents/category-upload-dialogs/file-edit/file-edit.component';
import { AccessionSelectComponent } from './upload-documents/category-upload-dialogs/form-fields/accession-select.component';
import { DocumentLetterNumberComponent } from './upload-documents/category-upload-dialogs/form-fields/document-textfield/document-letter-number.component';
import { DocumentTitleComponent } from './upload-documents/category-upload-dialogs/form-fields/document-textfield/document-title.component';
import { DocumentVersionNumberComponent } from './upload-documents/category-upload-dialogs/form-fields/document-textfield/document-version-number.component';
import { ProjectSelectComponent } from './upload-documents/category-upload-dialogs/form-fields/project-select.component';
import { SiteSelectByProjectsComponent } from './upload-documents/category-upload-dialogs/form-fields/site-select-by-projects.component';
import { SitesSelectComponent } from './upload-documents/category-upload-dialogs/form-fields/sites-select.component';
import { SubjectSelectComponent } from './upload-documents/category-upload-dialogs/form-fields/subject-select.component';
import { ApplicationTrainingUploadComponent } from './upload-documents/category-upload-dialogs/general/application-training-upload.component';
import { GeneralCommunicationsUploadComponent } from './upload-documents/category-upload-dialogs/general/general-communications-upload.component';
import { GeneralLabManualsUploadComponent } from './upload-documents/category-upload-dialogs/general/general-lab-manuals-upload.component';
import { GeneralTrainingMaterialsUploadComponent } from './upload-documents/category-upload-dialogs/general/general-training-materials-upload.component';
import { ExcelParser } from './upload-documents/category-upload-dialogs/site-specific/excel-parser';
import { LabManualsUploadComponent } from './upload-documents/category-upload-dialogs/site-specific/lab-manuals-upload.component';
import { SiteActionsUploadComponent } from './upload-documents/category-upload-dialogs/site-specific/site-actions-upload.component';
import { SiteCommunicationsMassUploadComponent } from './upload-documents/category-upload-dialogs/site-specific/site-communications-mass-upload.component';
import { SiteCommunicationsUploadComponent } from './upload-documents/category-upload-dialogs/site-specific/site-communications-upload.component';
import { SponsorCommunicationsUploadComponent } from './upload-documents/category-upload-dialogs/site-specific/sponsor-communications-upload.component';
import { TrainingMaterialsUploadComponent } from './upload-documents/category-upload-dialogs/site-specific/training-materials-upload.component';
import { UploadErrorDialogComponent } from './upload-documents/category-upload-dialogs/site-specific/upload-error-dialog.component';
import { DocumentTranslationUploadComponent } from './upload-documents/category-upload-dialogs/translations/document-translation-upload.component';
import { AdminDocumentsComponent } from './upload-documents/admin-documents.component';
import { FileExtensions } from './upload-documents/category-upload-dialogs/file-extensions';
import { AdminDocumentsFilterItemsStorage } from './upload-documents/filter/admin-documents-filter-items-storage';
import { HideDocumentComponent } from './upload-documents/hide-document.component';
import { ELearningUploadStorage } from './upload-documents/storages/e-learning-upload-storage';
import { SiteCommunicationsMassUploadStorage } from './upload-documents/storages/site-communications-mass-upload-storage';
import { UploadedDocumentsStorage } from './upload-documents/storages/uploaded-documents-storage';
import { UploadActionsMenuAgRendererComponent } from './upload-documents/upload-actions-menu-ag-renderer.component';
import { AdminDocumentsFilterResolver } from './upload-documents/filter/admin-documents-filter-resolver';
import { UploadedDocumentsRequestCreator } from './upload-documents/storages/uploaded-documents-request-creator';
import { UploadedTranslationsStorage } from './upload-documents/category-upload-dialogs/translations/uploaded-translations-storage';
import { UserProfilesActionsMenuAgRendererComponent } from './user-profiles/user-profiles-actions-menu-ag-renderer.component';
import { UserProfilesStorage } from './user-profiles/user-profiles-storage';
import { UserProfilesComponent } from './user-profiles/user-profiles.component';
import { UserResolver } from './users/user-resolver';
import { UsersStorage } from './users/users-storage';
import { CategorySelectComponent } from './upload-documents/category-upload-dialogs/form-fields/category-select.component';
import { UserPermissionsModule } from '../user-permissions/user-permissions.module';
import { AdminSponsorsStorage } from './sponsor-storage/admin-sponsors-storage';
import { SetDefaultAdminReportsFiltersGuard } from './activity-reports/documents/set-default-admin-reports-filters-guard';
import { ProjectsSelectByProtocolComponent } from './upload-documents/category-upload-dialogs/form-fields/projects-select-by-protocol.component';
import { AdminKitInventoryOnHandComponent } from './kit-inventory/admin-kit-inventory-onhand.component';
import { AdminKitInventoryExpirationComponent } from './kit-inventory/admin-kit-inventory-expiration.component';
import { AdminEQuerySummaryComponent } from './e-query/e-query-summary/admin-e-query-summary.component';
import { AdminEquerySummaryFiltersGuard } from './e-query/e-query-summary/admin-e-query-summary-filters-guard';
import { AdminEQueryPreviewDialogComponent } from './e-query/e-query-preview/admin-e-query-preview-dialog.component';
import { CorporateModule } from '../corporate/corporate.module';
import { EQuerySummaryStorage } from './e-query/e-query-summary/e-query-summary-storage';
import { FilterUrlParamsPreparer } from './e-query/e-query-summary/filter-url-params-preparer';
import { AdminEQuerySummaryColumns } from './e-query/e-query-summary/admin-e-query-summary-columns';
import { AdminEQueryModule } from './e-query/admin-e-query.module';
import { EQueriesModule } from '../e-queries/e-queries.module';
import { AdminEQueryFilterDefinitionsResolver } from './e-query/admin-e-query-filter-definitions-resolver';
import { PrefilledEQueryCreateFormComponent } from './e-query/prefiled-query-edit/prefilled-e-query-create-form.component';
import { SetDefaultAdminEmailNotificationFiltersGuard } from './activity-reports/email-alerts/set-default-admin-email-notification-filters-guard';
import { EditDefaultColumnsComponent } from './edit-default-columns/edit-columns.component';
import { AdminEditColumnStorage } from './edit-default-columns/admin-edit-column-storage';
import { AdminColumnFormComponent } from './edit-default-columns/column-form/admin-column-form.component';
import { AdminEditColumnService } from './edit-default-columns/admin-edit-column-service';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { SampleTrackingModule } from '../sample-tracking/sample-tracking.module';
@NgModule({
    declarations: [
        AdminEQuerySummaryComponent,
        AdminEQueryPreviewDialogComponent,
        AnnouncementsAdminComponent,
        AnnouncementsActionsMenuAgRendererComponent,
        AnnouncementEditDialogComponent,
        AnnouncementDeleteDialogComponent,
        CommonLinksGridComponent,
        CommonLinkActionsMenuAgRendererComponent,
        ProtocolActivationComponent,
        AdminDocumentsComponent,
        ProtocolChangeAccessibilityComponent,
        GeneralLabManualsUploadComponent,
        GeneralTrainingMaterialsUploadComponent,
        GeneralCommunicationsUploadComponent,
        DocumentTranslationUploadComponent,
        ApplicationTrainingUploadComponent,
        LabManualsUploadComponent,
        SiteCommunicationsUploadComponent,
        SiteActionsUploadComponent,
        SponsorCommunicationsUploadComponent,
        TrainingMaterialsUploadComponent,
        CommonLinkEditorComponent,
        UploadActionsMenuAgRendererComponent,
        UserProfilesActionsMenuAgRendererComponent,
        UserProfilesComponent,
        DocumentTitleComponent,
        DocumentLetterNumberComponent,
        DocumentVersionNumberComponent,
        AccessionSelectComponent,
        ProjectsSelectByProtocolComponent,
        ProjectSelectComponent,
        CategorySelectComponent,
        SiteSelectByProjectsComponent,
        SitesSelectComponent,
        SubjectSelectComponent,
        UploadDialogActionButtonsComponent,
        UploadProgressComponent,
        StudyManualInfoComponent,
        GeneralDocumentInfoComponent,
        ApplicationTrainingInfoComponent,
        SiteCommunicationsInfoComponent,
        SponsorCommunicationsInfoComponent,
        TrainingMaterialsInfoComponent,
        HideDocumentComponent,
        FileEditComponent,
        SiteCommunicationsMassUploadComponent,
        AdminNavigationComponent,
        AuditTrailExportComponent,
        UploadErrorDialogComponent,
        AdminKitInventoryComponent,
        AdminKitInventoryOnHandComponent,
        AdminKitInventoryExpirationComponent,
        AdminLevelComponent,
        PrefilledEQueryCreateFormComponent,
        EditDefaultColumnsComponent,
        AdminColumnFormComponent
    ],
    imports: [
        SharedModule,
        AdminFormFieldsModule,
        GlobalPopupModule,
        ReactiveFormsModule,
        CovanceAgGridModule,
        CovanceDatePickerModule,
        QuillModule,
        CovanceFileUploadModule,
        CovanceTextFieldModule,
        InvestigatorModule,
        UserModule,
        UserPermissionsModule,
        AuditTrailModule,
        NavigationModule,
        CovanceFilterModule,
        AdminActivityReportsModule,
        DocumentsModule,
        AdminSharedModule,
        CorporateModule,
        AdminEQueryModule,
        EQueriesModule,
        DragDropModule
    ],
    providers: [
        GridColumns,
        StandardTitlesStorage,
        AnnouncementsInfoStorage,
        CommonLinksInfoStorage,
        AdminProtocolsStorage,
        ProjectsStorage,
        AccessionsStorage,
        AdminSubjectsStorage,
        EQueryStorage,
        CommonLinksInfoEditor,
        AdminDocumentColumns,
        UploadDialogTypeResolver,
        UploadedDocumentsStorage,
        ELearningUploadStorage,
        SiteCommunicationsMassUploadStorage,
        UploadedDocumentsRequestCreator,
        UserProfilesStorage,
        UploadedTranslationsStorage,
        AdminGuard,
        SetDefaultAdminDocumentsFiltersGuard,
        SetDefaultAdminReportsFiltersGuard,
        UploadConfirmationDialog,
        ExcelParser,
        UserResolver,
        UsersStorage,
        AdminLinksInfoStorage,
        AdminDocumentsFilterItemsStorage,
        AdminDocumentsFilterResolver,
        AuditTrailRecordsStorage,
        AdminUnreadReportStorage,
        FileExtensions,
        AdminSponsorsStorage,
        AdminDocumentsMandatoryFilterItemsStorage,
        EQuerySummaryStorage,
        AdminEQuerySummaryColumns,
        FilterUrlParamsPreparer,
        AdminEQueryFilterDefinitionsResolver,
        SetDefaultAdminEmailNotificationFiltersGuard,
        AdminEquerySummaryFiltersGuard,
        AdminEditColumnStorage,
        AdminEditColumnService
    ],
    entryComponents: [
        AnnouncementsActionsMenuAgRendererComponent,
        AnnouncementEditDialogComponent,
        AnnouncementDeleteDialogComponent,
        CommonLinkActionsMenuAgRendererComponent,
        CommonLinkEditorComponent,
        ProtocolChangeAccessibilityComponent,
        GeneralLabManualsUploadComponent,
        GeneralTrainingMaterialsUploadComponent,
        GeneralCommunicationsUploadComponent,
        DocumentTranslationUploadComponent,
        ApplicationTrainingUploadComponent,
        LabManualsUploadComponent,
        SiteCommunicationsUploadComponent,
        SiteActionsUploadComponent,
        SponsorCommunicationsUploadComponent,
        TrainingMaterialsUploadComponent,
        UploadActionsMenuAgRendererComponent,
        UserProfilesActionsMenuAgRendererComponent,
        HideDocumentComponent,
        FileEditComponent,
        UploadErrorDialogComponent,
        AdminEQueryPreviewDialogComponent,
        AdminColumnFormComponent
    ]
})
export class AdminModule { }
